import { z } from "zod";

const BooleanString = z
  .enum(["true", "false"])
  .transform((value) => value === "true")
  .catch(true);

export const GameSettingsSchema = z.object({
  first_letter: BooleanString,
  typing_feedback: BooleanString,
  hint: BooleanString,
  time_rewards: BooleanString,
});

export type Strictness = {
  cap: boolean; // capitalization
  pun: boolean; // punctuation
  acc: boolean; // accents
};

export type GameSettings = {
  isFirstLetterShown: boolean;
  isTypingFeedbackShown: boolean;
  isHintEnabled: boolean;
  isTimeRewardEnabled: boolean;
  isPercentShown: boolean;
  strictness: Strictness;
};
